import React from 'react';

export default function CarryingLoads({ className }) {
    return (
        <svg className={`${className}  w-8 h-8`} fill="#e20303" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            {/* Person head */}
            <circle cx="12" cy="5" r="2"/>
            
            {/* Body */}
            <path d="M12 7v6"/>
            
            {/* Arms carrying box */}
            <path d="M8 10h-3l-2 4h5m13-4h-3l-2-4"/>
            
            {/* Heavy box/load */}
            <rect x="7" y="12" width="10" height="8" rx="1"/>
            
            {/* Legs */}
            <path d="M10 20l-2 2m6-2l2 2"/>
            <path d="M9 13v7m6-7v7"/>
        </svg>
    );
}